import type { ApiRoute, NoBody, NoQueryParams } from "../../../api"
import type { VisibilityView } from "./VisibilityView"

export interface GetVisibilityViewPathParams {
	inventoryId: string
}

export const getVisibilityRoute: ApiRoute<GetVisibilityViewPathParams, NoQueryParams, NoBody, VisibilityView> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/visibility`,
	method: "get",
	path: "/vehicles/:inventoryId/visibility",
}
